var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "candidate-navbar",
        staticStyle: { "background-color": "#3b425d" },
      },
      [
        _vm.isShowOnBoardData
          ? _c(
              "button",
              {
                staticStyle: { "background-color": "#18c58b", color: "#fff" },
                attrs: { type: "button" },
                on: { click: _vm.gotToPage },
              },
              [_vm._v(" 報到資料 ")]
            )
          : _vm._e(),
        _c(
          "button",
          {
            staticStyle: { "background-color": "#18c58b", color: "#fff" },
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.$common.downloadPersonnelInformationPDF(
                  _vm.resumeType,
                  _vm.matchId
                )
              },
            },
          },
          [_vm._v(" 下載 PDF ")]
        ),
        _c(
          "a",
          {
            attrs: { href: "javascript:void(0)" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.$router.go(-1)
              },
            },
          },
          [_vm._v("返回")]
        ),
      ]
    ),
    _c(
      "div",
      { staticClass: "step-page" },
      [
        _c(
          "h3",
          { staticClass: "mb-3 text-center", staticStyle: { color: "#fff" } },
          [_vm._v("人事資料表")]
        ),
        _c(
          "el-tabs",
          {
            staticClass: "tab-component",
            attrs: { "tab-position": _vm.windowWidth > 1024 ? "left" : "top" },
            model: {
              value: _vm.activeName,
              callback: function ($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName",
            },
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: "面談背景資料",
                  name: "面談背景資料",
                  lazy: "",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg mt-3" },
                  [
                    _c("WorkedInfo", {
                      key: _vm.workedInfoKey,
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "基本資料", name: "基本資料", lazy: "" } },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg mt-3" },
                  [
                    _c("BaseInfo", {
                      key: _vm.baseInfoKey,
                      ref: "baseInfo",
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                        changePage: _vm.changePage,
                        person: _vm.person,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "學歷", name: "學歷", lazy: "" } },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg" },
                  [
                    _c("div", { staticClass: "step-tip mb-2" }, [
                      _vm._v(
                        " ** 請至少提供一項已經修業完成的學歷，並從最高學歷開始填寫，且至少提供一項已經修業完成的學歷，而若資料庫中無您的母校，請直接填寫校名。 "
                      ),
                    ]),
                    _c("Education", {
                      key: _vm.educationKey,
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "工作經歷", name: "工作經歷", lazy: "" } },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg" },
                  [
                    _c("div", { staticClass: "step-tip mb-2" }, [
                      _vm._v(
                        " ** 請從最近一份工作經歷開始填起，「薪資」請填寫阿拉伯數字，例如：「29,000」。 "
                      ),
                    ]),
                    _c("WorkExperience", {
                      key: _vm.workExperienceKey,
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "專業技能", name: "專業技能", lazy: "" } },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg mt-3" },
                  [
                    _c("Skill", {
                      key: _vm.skillKey,
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "活動經驗", name: "活動經驗", lazy: "" } },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg mt-3" },
                  [
                    _c("Activity", {
                      key: _vm.activityKey,
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "語言能力", name: "語言能力", lazy: "" } },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg" },
                  [
                    _c("div", { staticClass: "step-tip mb-2" }, [
                      _vm._v(
                        " * 請用優、良、可、劣四個等級來評比自己聽、說、讀、寫的能力。 "
                      ),
                    ]),
                    _c("Language", {
                      key: _vm.languageKey,
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "工作配合", name: "工作配合", lazy: "" } },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg mt-3" },
                  [
                    _c("WorkCooperation", {
                      key: _vm.workCooperationKey,
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "面試情況", name: "面試情況", lazy: "" } },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg mt-3" },
                  [
                    _c("InterviewStatus", {
                      key: _vm.interviewStatusKey,
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "職缺需求", name: "職缺需求", lazy: "" } },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg mt-3" },
                  [
                    _c("WorkConsideration", {
                      key: _vm.workConsiderationKey,
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "保密義務", name: "保密義務", lazy: "" } },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg" },
                  [
                    _c("div", { staticClass: "step-tip mb-2" }, [
                      _vm._v(
                        " 註：「保密義務」是指您對於前雇主的機密資訊負有保密責任，離職之後不得繼續使用、揭露或持有。"
                      ),
                      _c("br"),
                      _vm._v(
                        " ** 提醒您，以下說明內容應真確詳實，並與您所簽訂的保密義務條款相同。 "
                      ),
                    ]),
                    _c("Confidentiality", {
                      key: _vm.confidentialityKey,
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "禁止條款", name: "禁止條款", lazy: "" } },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg" },
                  [
                    _c("div", { staticClass: "step-tip mb-2" }, [
                      _vm._v(
                        " 註：「競業禁止」是指您曾與前雇主約定，在離職後的一定期間內，不能受雇於與該前雇主之營業性質相同或類似的工作。"
                      ),
                      _c("br"),
                      _vm._v(
                        " ** 提醒您，以下說明內容應真確詳實，並與您所簽訂的競業禁止條款相同。 "
                      ),
                    ]),
                    _c("NonCompete", {
                      key: _vm.nonCompeteKey,
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "智財", name: "智財", lazy: "" } },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg mt-3" },
                  [
                    _c("IntellectualProperty", {
                      key: _vm.intellectualPropertyKey,
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "自傳", name: "自傳", lazy: "" } },
              [
                _c(
                  "div",
                  { staticClass: "step-content no-bg" },
                  [
                    _c("Autobiography", {
                      key: _vm.autobiographyKey,
                      attrs: {
                        source: "personnelInformation",
                        matchId: _vm.matchId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }